Number.prototype.getSumOfDigits = function(): number {
    let absValue = Math.abs(this);
    let result = 0;
    while (absValue > 0) {
        result += absValue % 10;
        absValue = Math.floor(absValue / 10);
    }
    return result;
};
